import { render, staticRenderFns } from "./AreaDetailsDialog.vue?vue&type=template&id=6707b464&"
import script from "./AreaDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AreaDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports